import React from 'react';

import Thumb from '../img/works/hu.jpg';
import About from '../img/work-details/hu-about.jpg';
import Footer from '../img/work-details/hu-footer.jpg';

const Hu = {
    id: 5, permalink: "hu", thumb: Thumb, title: "Hu", category: "PSD to HTML", categoryURL: "psdtohtml", detailImg1: About, detailImg2: Footer, previewTxt: "Preview", previewURL: "https://wasek23.github.io/hu/", sourceTxt: "PSD Source", sourceURL: "https://dribbble.com/shots/4927487-Daily-UI-028-Digital-Design-Agency-Home-Page-Free-PSD", description: <>
        <h3 className="mbSmall">Hu is a PSD To HTML Template.</h3>
        <p>&nbsp;</p>

        <h5>Main Feature:</h5>
        <ul>
            <li>Design with HTML5 &amp; CSS3</li>
            <li>Google Web Font Included</li>
            <li>Social Share Icons</li>
            <li>Footer Weights</li>
        </ul>

        <h5>Unfavorable:</h5>
        <ul>
            <li>No Responsive</li>
        </ul>
    </>
};
export default Hu;